module.exports = __webpack_public_path__ + "img/logoblue.2fb160f3.svg";